
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.9 4a.6.6 0 01.6-.6h11a.6.6 0 110 1.2h-11A.6.6 0 01.9 4zM2.4 7a.6.6 0 01.6-.6h8a.6.6 0 110 1.2H3a.6.6 0 01-.6-.6zM5 9.4a.6.6 0 000 1.2h4a.6.6 0 100-1.2H5z","fill":"#58697D"}})])
          )
        }
      }
    